import { BadgeVariant } from '../components/common/Badge';

// Mirrors GolfPlayed.Domain/Enums/CourseRequestStatus.cs.
//
// The generated client types status as a number (_0/_1/_2, no names), but the API actually sends
// the enum's name ("Pending"): the Functions host serialises enums as strings while the swagger
// document still describes them as ints. Anything reading a status goes through
// courseRequestStatusName so it works with either, and nothing compares against the raw value.
export type CourseRequestStatusName = 'Pending' | 'Approved' | 'Declined';

const NAMES_BY_NUMBER: CourseRequestStatusName[] = [
  'Pending',
  'Approved',
  'Declined',
];

export const courseRequestStatusName = (
  status: unknown,
): CourseRequestStatusName | undefined => {
  if (typeof status === 'number') {
    return NAMES_BY_NUMBER[status];
  }
  if (typeof status === 'string') {
    return NAMES_BY_NUMBER.find(
      (n) => n.toLowerCase() === status.toLowerCase(),
    );
  }
  return undefined;
};

// The numbers the API accepts in a search filter. It takes the numeric form as well as the name.
export const COURSE_REQUEST_STATUS_VALUES: Record<
  CourseRequestStatusName,
  number
> = {
  Pending: 0,
  Approved: 1,
  Declined: 2,
};

export const COURSE_REQUEST_STATUS_BADGES: Record<
  CourseRequestStatusName,
  BadgeVariant
> = {
  Pending: 'warning',
  Approved: 'success',
  Declined: 'default',
};
